export const BASE_URL = "https://vyl-asociados.com/public/images/";
export const BASE_URL_DOCUMENTS = "https://vyl-asociados.com/public/";
export const API_BASE_URL = "https://vyl-asociados.com/backend/public/api/";

